import React, { useEffect, useState } from "react";
import { Container, Grid } from "@mantine/core";
import { TopListTable } from "components/SupplierDashboard/topLitTable";

const SalesDashboard = ({ data, selectedBadge, setSelectedBadge }) => (
  <Container
    style={{ marginTop: "10px", marginLeft: "0px", maxWidth: "1200px" }}
  >
    <Grid>
      <Grid.Col span={4}>
        <TopListTable
          data={data?.top_suppliers || []}
          title="Top Suppliers"
          headers={["Name", "Sales"]}
          dataKeys={["name", "total_sales"]}
          selectedBadge={selectedBadge}
          setSelectedBadge={setSelectedBadge}
        />
      </Grid.Col>
      <Grid.Col span={4}>
        <TopListTable
          data={data?.top_drivers || []}
          title="Top Drivers"
          headers={["Name", "Drop-offs"]}
          dataKeys={["name", "total_dropoffs"]}
          selectedBadge={selectedBadge}
          setSelectedBadge={setSelectedBadge}
        />
      </Grid.Col>
      <Grid.Col span={4}>
        <TopListTable
          data={data?.top_retailers || []}
          title="Top Retailers"
          headers={["Name", "Orders"]}
          dataKeys={["name", "total_orders"]}
          selectedBadge={selectedBadge}
          setSelectedBadge={setSelectedBadge}
        />
      </Grid.Col>
        <Grid.Col span={4}>
        <TopListTable
          data={data?.top_sme || []}
          title="Top SMEs"
          headers={["Name", "Sales"]}
          dataKeys={["name", "total_sales"]}
          selectedBadge={selectedBadge}
          setSelectedBadge={setSelectedBadge}
        />
      </Grid.Col>
    </Grid>
  </Container>
);

export default SalesDashboard;
